<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>新手引导进度统计</span>
    </div>
    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
        <!--        <el-button v-permisaction="['config:userStatData:export']" icon="el-icon-download" size="mini" @click="exportData(2)">导出</el-button>-->
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="date"
        label="日期"
        width="180"
      />
      <el-table-column
        prop="count"
        label="人数"
        width="180"
      />
      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item"
        width="180"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.data[index]"> {{ scope.row.data[index] }}%</span>
          <span v-else>0</span>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import { dateStrTodate, getLastDates } from '@/utils'
import { getFinishtutorial } from '@/api/statistics/user_remain'

export default {
  name: 'Finishtutorial',
  data() {
    return {
      tableData: [],
      tableHeader: [],
      loading: false,
      queryParams: {
        startDate: '',
        endDate: ''
      }
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(1)
    this.getTables()
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }

      this.getTables()
    },
    getTables() {
      this.loading = true
      getFinishtutorial(this.queryParams).then(res => {
        const { data, type } = res.data
        this.tableHeader = type
        this.tableData = data
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
